import React from 'react';

import Checkbox from '@amzn/meridian/checkbox';
import Column from '@amzn/meridian/column';
import type { RegionTaskModification } from 'src/services/tasks/types';

// **** Types **** //

interface ModificationListProps {
  modifications: RegionTaskModification[];
  enabled: Set<number>;
  onToggle: (modificationId: number, checked: boolean) => void;
}

// **** Components **** //

/**
 * Presentational list of modification checkboxes for a single task. Each
 * modification in the catalog is a row; a checked box means it's assigned to the
 * task. Task-groups use `ModificationMatrix` instead. State and chrome are owned
 * by `ModificationEditor`.
 */
const ModificationList = ({ modifications, enabled, onToggle }: ModificationListProps) => (
  <Column spacing="300">
    {modifications.map((mod) => (
      <Checkbox
        key={mod.modificationId}
        checked={enabled.has(mod.modificationId)}
        onChange={(checked) => onToggle(mod.modificationId, checked)}
      >
        {mod.name}
      </Checkbox>
    ))}
  </Column>
);

// **** Export **** //

export default ModificationList;
